import { render, staticRenderFns } from "./ChooseValuesSlide.vue?vue&type=template&id=21628846"
import script from "./ChooseValuesSlide.vue?vue&type=script&lang=js"
export * from "./ChooseValuesSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21628846')) {
      api.createRecord('21628846', component.options)
    } else {
      api.reload('21628846', component.options)
    }
    module.hot.accept("./ChooseValuesSlide.vue?vue&type=template&id=21628846", function () {
      api.rerender('21628846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/ChooseValuesSlide.vue"
export default component.exports